export default "__VITE_ASSET__6be466a8__"